module.exports = __webpack_public_path__ + "img/amaro-filtro.cde71397.png";